<span class="status">
  @switch (status) {
    @case (DomainStatus.Verified) {
      <img alt="" src="/assets/default/input-approved.svg">
    }
    @case (DomainStatus.Deleted) {
      <img alt="" src="/assets/default/input-error.svg">
    }
    @case (DomainStatus.Pending) {
      <img alt="" src="/assets/default/clock.svg">
    }
  }
  {{ DomainStatusPresentation(status) }}
</span>
